



















































import Vue from 'vue';
import { Pay } from '../models/Fee';
import accountClient from '../../account/apis';
import moment from 'moment';

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    payType: {
      type: Number,
      default: Pay.Wx,
    },
    fee: {
      type: Number,
      default: null,
    },
    wxCodeUrl: {
      type: String,
      default: null,
    },
    orderId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showPayBox: false,
      Pay,
      paySuccess: false,
      orderTime: null,
      wxQrcodeUrl: null,
      countdown: 3,
      moment,
    };
  },
  mounted() {
    this.showPayBox = this.show;
    this.wxQrcodeUrl = 'http://crm.drip.im/api-crm-web/common/qrcode?content=' + this.wxCodeUrl;
    this.checkPayStatus();
  },
  methods: {
    payOk() {
      if (this.paySuccess) {
        window.location.href = '#/customer/search';
      } else {
        this.$Message.error('系统检查尚未支付成功，请稍后再试');
      }
    },
    toIndex() {
      const goto = setInterval(() => {
        this.countdown = this.countdown - 1;
        if (this.countdown === 0) {
          clearInterval(goto);
          window.location.href = '#/customer/search';
        }
      }, 1000);
    },
    checkPayStatus() {
      const checkJob = setInterval(() => {
        if (this.orderId && this.show) {
          accountClient.getOrderStatus({id: this.orderId}).success(r => {
            if (r.confirmed) {
              this.paySuccess = true;
              this.orderTime = moment().format('YYYY-MM-DD HH:mm');
              clearInterval(checkJob);
              if (this.payType === Pay.Wx) {
                this.toIndex();
              }
            }
          });
        }
      }, 1000);
    },
    close() {
      this.$emit('close');
    },
  },
  watch: {
    show() {
      this.showPayBox = this.show;
      this.wxQrcodeUrl = 'http://crm.drip.im/api-crm-web/common/qrcode?content=' + this.wxCodeUrl;
      this.checkPayStatus();
    },
  },
});
